<template>
  <a-card class='mb15' :bordered='false'>
    <div class="s_flex_bian_c">
      <div class="s_flex_ali">
        <img class="width-20 height-20 m-r-10" src="@/assets/images/data.png" alt="">
        <p class="s_font_b fz-18 s_c000">概况</p>
      </div>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item>
          <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.day_type_other">
            <a-radio-button :value="1">7天</a-radio-button>
            <a-radio-button :value="2">30天</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="">
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
            :disabled-date="disabledDate" @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-divider />
    <div class="s_bfbf s_bor10 s_flex_bian_c p-t-25 p-b-25">
      <div class="width20 s_flex_center">
        <div>
          <p class="fz-16 s_c000">积分订单</p>
          <p class="s_font_b s_c376 fz-30 m-t-3 m-b-3">{{totalData.order_count}}</p>
          <div class="s_c999 height-22">
            <div class="s_flex_ali">
              <p :class="totalData.order_count_type ? 'balanceUp':'balanceDown'">{{totalData.order_count_type ?
                '同比增长':'同比降低'}}</p>
              <span class="m-l-5 m-r-5"
                :class="totalData.order_count_type ? 'balanceUp':'balanceDown'">{{totalData.order_count_percentage}}</span>
              <img class="width-10 height-16" v-if='totalData.order_count_type' src="@/assets/images/up.png" alt="">
              <img class="width-10 height-16" v-else src="@/assets/images/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="width20 s_flex_center s_bor_bl1_cd0d">
        <div>
          <p class="fz-16 s_c000">礼品兑换量</p>
          <p class="s_font_b s_c000 fz-30 m-t-3 m-b-3">{{totalData.gift_count}}</p>
          <div class="s_c999 height-22">
            <div class="s_flex_ali">
              <p :class="totalData.gift_count_type ? 'balanceUp':'balanceDown'">{{totalData.gift_count_type ?
                '同比增长':'同比降低'}}</p>
              <span class="m-l-5 m-r-5"
                :class="totalData.gift_count_type ? 'balanceUp':'balanceDown'">{{totalData.gift_count_percentage}}</span>
              <img class="width-10 height-16" v-if='totalData.gift_count_type' src="@/assets/images/up.png" alt="">
              <img class="width-10 height-16" v-else src="@/assets/images/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="width20 s_flex_center s_bor_bl1_cd0d">
        <div>
          <p class="fz-16 s_c000">消耗积分</p>
          <p class="s_font_b s_c000 fz-30 m-t-3 m-b-3">{{totalData.pay_point_count}}</p>
          <div class="s_c999 height-22">
            <div class="s_flex_ali">
              <p :class="totalData.pay_point_count_type ? 'balanceUp':'balanceDown'">{{totalData.gift_count_type ?
                '同比增长':'同比降低'}}</p>
              <span class="m-l-5 m-r-5"
                :class="totalData.pay_point_count_type ? 'balanceUp':'balanceDown'">{{totalData.pay_point_count_percentage}}</span>
              <img class="width-10 height-16" v-if='totalData.pay_point_count_type' src="@/assets/images/up.png" alt="">
              <img class="width-10 height-16" v-else src="@/assets/images/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="width20 s_flex_center s_bor_bl1_cd0d">
        <div>
          <p class="fz-16 s_c000">消耗金额</p>
          <p class="s_font_b s_c000 fz-30 m-t-3 m-b-3">{{totalData.pay_price_count}}</p>
          <div class="s_c999 height-22">
            <div class="s_flex_ali">
              <p :class="totalData.pay_price_count_type ? 'balanceUp':'balanceDown'">{{totalData.gift_count_type ?
                '同比增长':'同比降低'}}</p>
              <span class="m-l-5 m-r-5"
                :class="totalData.pay_price_count_type ? 'balanceUp':'balanceDown'">{{totalData.pay_price_count_percentage}}</span>
              <img class="width-10 height-16" v-if='totalData.pay_price_count_type' src="@/assets/images/up.png" alt="">
              <img class="width-10 height-16" v-else src="@/assets/images/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-t-30">
      <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
    </div>
  </a-card>
  <a-card :bordered='false'>
    <p class="s_font_b fz-18 s_c000 m-b-25">热门礼品兑换</p>
    <a-row :gutter="30">
      <a-col :span="8">
        <echartCake :echartsData='cakeData' v-if='!listLoading'></echartCake>
      </a-col>
      <a-col :span="16">
        <a-table :pagination='false' :loading='listLoading' :columns='columns' :data-source='saveData' rowKey='name'  bordered>
          <template v-slot:info="{ record }">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+record.product_image" alt="" style="width:50px;height: 50px;object-fit:cover">
              </template>
              <template #description>{{record.name}}</template>
            </a-card-meta>
          </template>
          <template v-slot:price="{ record }">
            <span v-if='record.price_type == 2'>{{record.price}}元+</span>
            <span class="m-r-5">{{record.point}}积分</span>
          </template>
        </a-table>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
  import moment from "moment";
  import { reactive, ref, toRefs, onMounted } from "vue";
  import { getHomeData, getHomeCart, getHomeRank } from "@/api/index";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import { exchangeGiftGeneral } from "@/api/integralShop";
  import store from "@/store";
  const defSearch = {
    start_time: "",
    end_time: "",
    day_type: 1,  //0(搜索时间)，1(7天)，2(30天)
    day_type_other: 1  //1(7天)，2(30天)
  };
  export default {
    name: "Home",
    setup() {
      let search = ref({ ...defSearch });
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        echartData: {},
        cakeData: {},
        totalData: {},
        saveData: [],
        time: [],
      });
      const columns = [
        {
          title: "礼品信息",
          dataIndex: "info",
          key: "info",
          slots: { customRender: "info" }
        },
        {
          title: "礼品价格",
          dataIndex: "price",
          key: "price",
          slots: { customRender: "price" }
        },
        {
          title: "礼品兑换数量",
          dataIndex: "order_buy_count",
          key: "order_buy_count",
        }
      ];
      const onChangeRadio = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        search.value.day_type = search.value.day_type_other
      };
      const onChange = (e) => {
        if (!e.length) {
          search.value.start_time = "";
          search.value.end_time = "";
          state.time = [];
          search.value.day_type = 1;
          search.value.day_type_other = 1
          return false;
        }
        var day_num = getDaysBetween(e[0], e[1]) + 1;
        if (day_num < 3) {
          message.error("选择时间范围不得小于3天，建议选择时间范围为7天");
          search.value.start_time = "";
          search.value.end_time = "";
          state.time = [];
        } else {
          search.value.start_time = e[0];
          search.value.end_time = e[1];
          search.value.day_type = 0;
          search.value.day_type_other = ''
        }
      };
      function getDaysBetween(dateString1, dateString2) {
        var startDate = Date.parse(dateString1);
        var endDate = Date.parse(dateString2);
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        return days;
      }
      const initData = async () => {
          state.listLoading = true
        let res = await exchangeGiftGeneral(search.value).then((res) => res.data);
        if (iscode(res)) {
          state.saveData = res.data.saveData;
          state.totalData = res.data.totalData;
          state.cakeData.chartList = res.data.chartData;
          state.totalData.order_count_type = state.totalData.order_count_percentage.indexOf('+') !== -1 ? true : false
          state.totalData.gift_count_type = state.totalData.gift_count_percentage.indexOf('+') !== -1 ? true : false
          state.totalData.pay_point_count_type = state.totalData.pay_point_count_percentage.indexOf('+') !== -1 ? true : false
          state.totalData.pay_price_count_type = state.totalData.pay_price_count_percentage.indexOf('+') !== -1 ? true : false
          res.data.lineList.dataName = ['积分订单', '礼品兑换量', '消耗积分', '消耗金额']
          res.data.lineList.series = [
            {
              name: '积分订单',
              data: res.data.lineList.order_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '礼品兑换量',
              data: res.data.lineList.gift_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '消耗积分',
              data: res.data.lineList.pay_point_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '消耗金额',
              data: res.data.lineList.pay_price_count,
              type: 'line',
              symbolSize: 6,smooth: true
            }
          ]
          state.echartData = res.data.lineList;
          state.listLoading = false

        } else {
          message.error(res.msg);
        }
      };
      const disabledDate = (current) => {
        return current && current >= moment(new Date() - 86400000).endOf("day");
      };
      // 页面筛选项搜索
      const pageSearchChange = () => {
        initData();
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        search,
        columns,
        onChangeRadio,
        onChange,
        disabledDate,
        pageSearchChange
      };
    },
  };
</script>
<style>
  .balanceUp {
    color: #df412c;
  }

  .balanceDown {
    color: #4bb339;
  }

  .s_bor_bl1_cd0d {
    border-left: 1px solid #dde6f0;
  }
</style>